export default "__VITE_ASSET__CvOWgeUS__"